import React, { useState } from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Popover,
  Typography,
} from '@mui/material';
import { Flatware } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useFoodTypes } from 'src/constants';
import { formatPartialWeight } from 'src/hooks/usePartialRescueColumns';

const PopoverFoodTypes = ({ weights = [] }) => {
  const foodTypes = useFoodTypes();
  const { t } = useTranslation('translation');
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  let hoverTimeout = null;
  let rowElement = null;

  const handleMouseEnter = (event) => {
    rowElement = event.currentTarget.closest('.MuiDataGrid-row');
    if (rowElement) {
      rowElement.classList.remove('Mui-hovered');
    }

    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleMouseLeave = () => {
    hoverTimeout = setTimeout(() => {
      setOpen(false);
      setAnchorEl(null);

      if (rowElement) {
        rowElement.classList.add('Mui-hovered');
      }
    }, 100);
  };

  return (
    <>
      <Box
        sx={{
          color: (t) => t.palette.primary.main,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: '5px',
          cursor: 'pointer',
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Flatware />
      </Box>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleMouseLeave}
        disableScrollLock={true}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        onMouseEnter={() => clearTimeout(hoverTimeout)}
      >
        <Box onMouseLeave={handleMouseLeave} sx={{ p: 2, minWidth: 200 }}>
          <Typography sx={{ fontWeight: 'bold' }}>
            {t('donations.weights')}
          </Typography>
          <List dense>
            {weights.map((item, index) => (
              <ListItem key={index} sx={{ padding: '4px 0' }}>
                <ListItemText
                  primary={formatPartialWeight({ item, foodTypes })}
                  primaryTypographyProps={{ fontSize: '14px' }}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Popover>
    </>
  );
};

export default PopoverFoodTypes;
